var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mdi leading-none",class:`${_vm.name} text-${_vm.color}${_vm.colorIntensity ? '-' + _vm.colorIntensity : ''} text-${_vm.size}`})
}
var staticRenderFns = []

export { render, staticRenderFns }